// import "@/styles/globals.css";
// import Layout from "@/componets/Layout";
// import { RouteGuard } from "@/componets/RouteGuard";
// import { useEffect } from "react";
// import GeoRedirect from "@/utilities/GeoRedirect";
// import PageHeadScript from "@/utilities/Head/script";
// import PageHead from "@/utilities/Head/index";
// import App from "next/app";
// import productMeta from "../../json/meta.json";
// import { useRouter } from "next/router";

// class MyApp extends App {
//   static async getInitialProps({ Component, ctx }) {
//     let pageProps = {};
//     let path = "";
//     const { asPath } = ctx;
//     let pathname = asPath;
//     if (pathname) {
//       path = pathname.split("/");
//       const lastSlug = path[path.length - 1];
//       let metaData = productMeta[lastSlug] ? productMeta[lastSlug] : {};
//       let og_image =
//         "https://cdn.shopify.com/s/files/1/0021/0573/7291/files/brunomdus-share-image-a.webp?v=1716350495";
//       let title = "BrunoMD | Health and Wellness Products | Beauty Supplements";
//       let description =
//         "Health and wellness products rooted in the heart of Italy, made from all-natural ingredients. Pharmaceutical grade supplements to fuel your future.";
//       if (metaData) {
//         og_image = metaData?.meta?.image;
//         title = metaData?.meta?.title;
//         description = metaData?.meta?.description;
//       }
//       if (Component.getInitialProps) {
//         pageProps = await Component.getInitialProps(ctx);
//       }

//       ctx.customParams = {
//         imageUrl: og_image ? og_image : "",
//         title: title ? title : "",
//         description: description ? description : "",
//       };
//     }

//     return { pageProps };
//   }

//   render() {
//     const version = "ENG";
//     const script = true;
//     const { Component, pageProps } = this.props;
//     // useEffect(() => {
//     //   // window.addEventListener("load", (event) => {
//     //   //   console.log("page is fully loaded");
//     //   //   if(document.getElementById("hubspot-conversations-iframe")){
//     //   //     document.getElementById("hubspot-conversations-iframe").style.top = 0;
//     //   //     document.getElementById("hubspot-conversations-iframe").style.height = '80%';
//     //   //   }
//     //   // });
//     // }, []);
//     if (Component?.hideLayout) {
//       return (
//         <RouteGuard version={version}>
//           <GeoRedirect redirect />
//           {!Component?.isHideScript && <PageHeadScript />}
//           <Component {...pageProps} version={version} script={script} />
//         </RouteGuard>
//       );
//     } else {
//       return (
//         <RouteGuard version={version}>
//           <Layout version={version} script={script}>
//             <GeoRedirect redirect />
//             <PageHeadScript />
//             <Component {...pageProps} version={version} script={script} />
//           </Layout>
//         </RouteGuard>
//       );
//     }
//   }
// }

// export default MyApp;

import "@/styles/globals.css";
import Layout from "@/componets/Layout";
import { RouteGuard } from "@/componets/RouteGuard";
import { useEffect } from "react";
import GeoRedirect from "@/utilities/GeoRedirect";
import PageHeadScript from "@/utilities/Head/script";
import PageHead from "@/utilities/Head/index";
import App from "next/app";
import productMeta from "../../json/meta.json";
import { useRouter } from "next/router";
import { HelmetProvider } from "react-helmet-async";

class MyApp extends App {
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};
    let path = "";
    const { asPath } = ctx;
    let pathname = asPath;
    if (pathname) {
      path = pathname.split("/");
      const lastSlug = path[path.length - 1];
      let metaData = productMeta[lastSlug] ? productMeta[lastSlug] : {};
      let og_image =
        "https://cdn.shopify.com/s/files/1/0021/0573/7291/files/brunomdus-share-image-a.webp?v=1716350495";
      let title = "BrunoMD | Health and Wellness Products | Beauty Supplements";
      let description =
        "Health and wellness products rooted in the heart of Italy, made from all-natural ingredients. Pharmaceutical grade supplements to fuel your future.";
      if (metaData) {
        og_image = metaData?.meta?.image;
        title = metaData?.meta?.title;
        description = metaData?.meta?.description;
      }
      if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(ctx);
      }

      ctx.customParams = {
        imageUrl: og_image ? og_image : "",
        title: title ? title : "",
        description: description ? description : "",
      };
    }

    return { pageProps };
  }

  render() {
    const version = "ENG";
    const script = true;
    const { Component, pageProps } = this.props;

    if (Component?.hideLayout) {
      return (
        <HelmetProvider>
          {" "}
          <RouteGuard version={version}>
            <GeoRedirect redirect />
            {!Component?.isHideScript && <PageHeadScript />}
            <Component {...pageProps} version={version} script={script} />
          </RouteGuard>
        </HelmetProvider>
      );
    } else {
      return (
        <HelmetProvider>
          {" "}
          <RouteGuard version={version}>
            <Layout version={version} script={script}>
              <GeoRedirect redirect />
              <PageHeadScript />
              <Component {...pageProps} version={version} script={script} />
            </Layout>
          </RouteGuard>
        </HelmetProvider>
      );
    }
  }
}

export default MyApp;
